// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"76":"fe2aef55","173":"27e0ec37","367":"95b2f3ab","661":"83be48a3"}[chunkId] + ".css";
};